// 2.E.3 — Hakukentta nav:n ylaeosaan.
//
// Debounced 300 ms — kayttajan kirjoittaminen ei aiheuta backend-pyyntoa
// joka nappain. Tila tallennetaan URL-parametri q.

import { useEffect, useState } from "react";
import { useLocation, useSearch } from "wouter";

export function SearchBar() {
  const search = useSearch();
  const [, navigate] = useLocation();

  const initialQ = new URLSearchParams(search.replace(/^\?/, "")).get("q") ?? "";
  const [value, setValue] = useState(initialQ);

  // Synkronoi URL → kentta jos URL muuttuu (esim. nav-linkki)
  useEffect(() => {
    const fromUrl = new URLSearchParams(search.replace(/^\?/, "")).get("q") ?? "";
    setValue(fromUrl);
  }, [search]);

  // Debounced submit URL:iin
  useEffect(() => {
    const handle = setTimeout(() => {
      const params = new URLSearchParams(window.location.search.replace(/^\?/, ""));
      const trimmed = value.trim();
      if (trimmed) params.set("q", trimmed);
      else params.delete("q");
      const qs = params.toString();
      // Aja Selaa-naekymaeaen jos haku-string ei ole tyhja
      const path = trimmed && !window.location.pathname.startsWith("/selaa") ? "/selaa" : window.location.pathname;
      navigate(qs ? `${path}?${qs}` : path);
    }, 300);
    return () => clearTimeout(handle);
  }, [value]);

  return (
    <input
      type="search"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Etsi tiedostonimesta…"
      className="w-64 rounded-md border border-slate-700 bg-slate-900 px-3 py-1.5 text-sm text-slate-100 placeholder-slate-500 focus:border-slate-500 focus:outline-none"
      aria-label="Etsi assetit"
    />
  );
}
